import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin'

console.log(1111)
if (document.getElementById('page-history') || document.getElementById('page-strategy')) {
  // #page-history または #page-strategy（.js-historyAnime 利用ページ）で実行

  page()
}

function page() {
  //  ####    #####  ##   ##  ##   ####  #####
  //  ##  ##  ##     ##   ##  ##  ##     ##
  //  ##  ##  #####  ##   ##  ##  ##     #####
  //  ##  ##  ##      ## ##   ##  ##     ##
  //  ####    #####    ###    ##   ####  #####
  // ウィンドウサイズがPC幅とSP幅の間で切り替わったときにリロード
  let currentIsSP = window.innerWidth <= 1024
  let resizeTimer = null

  window.addEventListener('resize', () => {
    // デバウンス処理（リサイズ終了後300ms待機）
    clearTimeout(resizeTimer)
    resizeTimer = setTimeout(() => {
      const newIsSP = window.innerWidth <= 1024

      // PC幅とSP幅の間で切り替わった場合のみリロード
      if (currentIsSP !== newIsSP) {
        window.location.reload()
      }
    }, 300)
  })

  //    ###    ##     ##  ##  ###    ###  #####
  //   ## ##   ####   ##  ##  ## #  # ##  ##
  //  ##   ##  ##  ## ##  ##  ##  ##  ##  #####
  //  #######  ##    ###  ##  ##      ##  ##
  //  ##   ##  ##     ##  ##  ##      ##  #####

  gsap.registerPlugin(ScrollTrigger, ScrollToPlugin)

  const historyAnime = document.querySelector('.js-historyAnime')
  if (!historyAnime) return

  const sections = historyAnime.querySelectorAll('.js-historyAnime--sec')
  const totalSections = sections.length

  if (totalSections === 0) return

  // ナビゲーション要素を取得（同一ページ内の該当ブロックに限定）
  const navItems = historyAnime.querySelectorAll('.js-historyNav')

  // セクションIDからインデックスを取得する関数
  const getSectionIndexById = (sectionId) => {
    return Array.from(sections).findIndex((section) => section.id === sectionId)
  }

  // ナビゲーションの.activeクラスを更新する関数
  const updateActiveNav = (sectionIndex) => {
    navItems.forEach((nav, idx) => {
      if (idx === sectionIndex) {
        nav.classList.add('active')
      } else {
        nav.classList.remove('active')
      }
    })
  }

  // SP幅の判定（1024px以下）
  const isSP = window.innerWidth <= 1024

  // SP幅の場合はGSAPアニメーションを無効化
  if (isSP) {
    // ナビゲーションクリック時の通常スクロール処理
    navItems.forEach((navItem) => {
      navItem.addEventListener('click', (e) => {
        e.preventDefault()
        const href = navItem.getAttribute('href')
        if (!href) return
        const targetSection = document.querySelector(href)
        if (targetSection) {
          targetSection.scrollIntoView({ behavior: 'smooth' })
        }
      })
    })

    // Intersection Observerで画面に入っているセクションを監視
    const observerOptions = {
      root: null,
      rootMargin: '-40% 0px -40% 0px', // 画面中央付近に入っているセクションを判定
      threshold: [0, 0.5, 1],
    }

    // 各セクションの交差状態を保持
    const sectionVisibility = new Map()

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const sectionId = entry.target.id
        sectionVisibility.set(sectionId, entry.intersectionRatio)
      })

      // 最も多く画面に入っているセクションを判定
      let maxRatio = 0
      let activeSectionId = null

      sectionVisibility.forEach((ratio, sectionId) => {
        if (ratio > maxRatio) {
          maxRatio = ratio
          activeSectionId = sectionId
        }
      })

      if (activeSectionId) {
        const sectionIndex = getSectionIndexById(activeSectionId)
        if (sectionIndex !== -1) {
          updateActiveNav(sectionIndex)

          // セクションに.animatedを付与
          sections.forEach((section, idx) => {
            if (idx === sectionIndex) {
              section.classList.add('animated')
            } else {
              section.classList.remove('animated')
            }
          })
        }
      }
    }, observerOptions)

    // 各セクションを監視対象に追加
    sections.forEach((section) => {
      observer.observe(section)
    })

    // 初期状態：最初のセクションに.animatedを付与
    if (sections[0]) {
      sections[0].classList.add('animated')
    }

    // 初期状態：最初のナビゲーションに.activeを付与
    if (navItems[0]) {
      navItems[0].classList.add('active')
    }

    return
  }

  // .js-historyAnime--secを固定配置にする
  sections.forEach((section) => {
    section.style.position = 'absolute'
    section.style.top = '0'
    section.style.left = '0'
    section.style.width = '100%'
    section.style.height = '100%'
  })

  // iOSのバウンススクロール対策
  const isIOS =
    /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)

  if (isIOS) {
    let lastTouchY = 0
    let touchStartY = 0

    document.addEventListener(
      'touchstart',
      (e) => {
        touchStartY = e.touches[0].clientY
        lastTouchY = touchStartY
      },
      { passive: true }
    )

    document.addEventListener(
      'touchmove',
      (e) => {
        if (!e.touches.length) return

        const currentY = e.touches[0].clientY
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop
        const scrollHeight = document.documentElement.scrollHeight
        const clientHeight = document.documentElement.clientHeight
        const deltaY = currentY - lastTouchY

        // スクロール上限での下方向スクロール（バウンス）を防止
        if (scrollTop <= 1 && deltaY > 0) {
          e.preventDefault()
          return false
        }
        // スクロール下限での上方向スクロール（バウンス）を防止
        if (scrollTop + clientHeight >= scrollHeight - 1 && deltaY < 0) {
          e.preventDefault()
          return false
        }

        lastTouchY = currentY
      },
      { passive: false }
    )
  }

  // ScrollTriggerインスタンスを保持
  let scrollTriggerInstance = null
  // スクロールアニメーション中かどうかを示すフラグ
  let isScrolling = false
  // 目標のセクションインデックス（アニメーション中に使用）
  let targetSectionIndex = null

  // .js-historyAnimeをpinするScrollTrigger
  scrollTriggerInstance = ScrollTrigger.create({
    trigger: historyAnime,
    start: 'top top',
    end: () => `+=${totalSections * window.innerHeight}`, // 各セクションごとに1画面分のスクロール距離
    pin: true,
    pinSpacing: true,
    anticipatePin: 1,
    pinType: 'fixed',
    onUpdate: (self) => {
      // スクロールアニメーション中は処理をスキップ
      if (isScrolling) return

      const progress = self.progress
      // 現在のセクションインデックスを計算（0から始まる）
      // 各セクションの範囲を正確に判定する
      // セクション0: 0 ～ 1/totalSections
      // セクション1: 1/totalSections ～ 2/totalSections
      // ...
      // セクションn-1: (n-1)/totalSections ～ 1.0
      let sectionIndex = Math.floor(progress * totalSections)
      // 最後のセクションの場合は、progressが1.0に近い場合も含める
      if (sectionIndex >= totalSections) {
        sectionIndex = totalSections - 1
      }

      // すべてのセクションに対して.animatedクラスを制御
      sections.forEach((section, idx) => {
        if (idx === sectionIndex) {
          // 現在のセクションに.animatedを付与
          section.classList.add('animated')
        } else {
          // それ以外のセクションから.animatedを削除
          section.classList.remove('animated')
        }
      })

      // ナビゲーションの.activeクラスを更新
      updateActiveNav(sectionIndex)
    },
  })

  // ナビゲーションクリック時のスクロールアニメーション時間（秒）
  const scrollAnimationDuration = 0.3

  // ナビゲーションクリック時のスクロール処理
  navItems.forEach((navItem) => {
    navItem.addEventListener('click', (e) => {
      e.preventDefault()

      // hrefからセクションIDを取得（例: #sec-01 → sec-01）
      const href = navItem.getAttribute('href')
      if (!href) return

      const sectionId = href.replace('#', '')
      const targetSection = document.getElementById(sectionId)
      if (!targetSection) return

      // セクションのインデックスを取得
      const sectionIndex = getSectionIndexById(sectionId)
      if (sectionIndex === -1) return

      // スクロール位置を計算（各セクションごとに1画面分）
      const scrollProgress = sectionIndex / totalSections

      // ScrollTriggerを使って該当セクションまでスクロール
      if (scrollTriggerInstance) {
        // 目標のprogressを計算
        // 各セクションの中央に来るように計算する
        // セクション0: 0.5 / totalSections
        // セクション1: 1.5 / totalSections
        // ...
        // セクションn-1: (n-0.5) / totalSections
        const targetProgress = (sectionIndex + 0.5) / totalSections
        // 最後のセクションの場合は、少し手前にする（1.0に近づきすぎないように）
        const finalProgress =
          sectionIndex === totalSections - 1 ? Math.min((sectionIndex + 0.4) / totalSections, 0.99) : targetProgress

        // ScrollTriggerの範囲内でのスクロール位置を計算
        const startY = scrollTriggerInstance.start
        const endY = scrollTriggerInstance.end
        const targetScrollY = startY + finalProgress * (endY - startY)

        // スクロールアニメーション開始
        isScrolling = true
        targetSectionIndex = sectionIndex

        // GSAPのscrollToアニメーションを使用
        gsap.to(window, {
          duration: scrollAnimationDuration,
          scrollTo: {
            y: targetScrollY,
            autoKill: false,
          },
          ease: 'power2.inOut',
          onComplete: () => {
            // アニメーション完了後、正確な位置に調整
            const finalScrollY = startY + finalProgress * (endY - startY)
            window.scrollTo(0, finalScrollY)

            // ScrollTriggerを更新してから状態を更新
            ScrollTrigger.refresh()

            // 目標セクションに.animatedを付与
            sections.forEach((section, idx) => {
              if (idx === targetSectionIndex) {
                section.classList.add('animated')
              } else {
                section.classList.remove('animated')
              }
            })

            // ナビゲーションの.activeクラスを更新
            updateActiveNav(targetSectionIndex)

            // フラグをリセット（少し遅延させてScrollTriggerの更新を待つ）
            setTimeout(() => {
              isScrolling = false
              targetSectionIndex = null
            }, 150)
          },
        })
      }
    })
  })

  // 初期状態：最初のセクションに.animatedを付与
  if (sections[0]) {
    sections[0].classList.add('animated')
  }

  // 初期状態：最初のナビゲーションに.activeを付与
  if (navItems[0]) {
    navItems[0].classList.add('active')
  }
}
